import { Redirect } from 'react-router-dom';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import { useFetchOnboardingStatus } from 'API/handlers/fetch-onboarding-status';
import navigationsRoute from 'app/routes/navigationsRoute';
import PageLoadingSpinner from '../../shareable/PageLoadingSpinner';

/**
 * After the user has logged in via LoginForm or EasyLogin, we display this
 * component. It loads some data from APIs and determines where to redirect
 * the user. While the data is loading, it shows a simple "loading" screen.
 */
function RedirectAfterLogin() {
  const [isUsingNewAirbnbLoading, isUsingNewAirbnb] =
    useFeatureToggle('Airbnb_new_wizard');
  const { data: onboardingStatus, isLoading: isLoadingOnboardingStatus } =
    useFetchOnboardingStatus();

  if (isUsingNewAirbnbLoading || isLoadingOnboardingStatus) {
    return <PageLoadingSpinner />;
  }

  // New users, who haven't seen the welcome message, will go to either the
  // Airbnb setup flow or the timeline, depending on a feature toggle.
  //
  // All other users go to the timeline.
  const isNew =
    isUsingNewAirbnb &&
    onboardingStatus &&
    !onboardingStatus.welcomeMessageSeen;
  const dest = isNew
    ? navigationsRoute.AIRBNB_ONBOARDING
    : navigationsRoute.IONIC_APP_HOME;
  return <Redirect to={dest} />;
}

export default RedirectAfterLogin;
